'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import PopTopicTimelineSkeleton from './PopTopicTimelineSkeleton';

const DynamicPopTopicTimeline = dynamic(() => import('./index'), {
  loading: () => <PopTopicTimelineSkeleton />,
  ssr: false
});

const DynamicLoadPopTopicTimeline = () => {
  return (
    <Suspense fallback={<PopTopicTimelineSkeleton />}>
      <DynamicPopTopicTimeline />
    </Suspense>
  );
};

export default DynamicLoadPopTopicTimeline;
